import Cookies from 'js-cookie';
import FetchData from '../Components/ServerCall/FetchData';
import Logger from '../Logger';
import {
  ICalculationFields,
  IConditionFilters,
  IFlows,
} from '../redux/Calculations/CurrentCalculationSessionInterface';
import { convertKeysToLowercase } from '../Components/Calculations/utils';

export interface IPayloadForColumn {
  tableId: string;
  fieldName: string;
  dataType: string;
  filterOption: string;
  timeGrain?: string;
  isCalculatedField?: boolean;
  calculatedField?: IPayloadForCalculation[];
}
export const fetchUniqueOptions = async (
  dbConnectionId: string,
  datasetId: string,
  workspaceId: string,
  payload: IPayloadForColumn,
) => {
  if (!dbConnectionId && !datasetId) {
    return {
      isError: true,
      message: 'Connection Id or datset Id atleast one of them is required',
      data: null,
    };
  }
  const res = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: `filter-options?dbconnectionid=${dbConnectionId}&datasetid=${datasetId}&workspaceId=${workspaceId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
    data: payload,
  });

  if (!res.status) {
    Logger('error', 'Error in fetching unique options for column', res.data);
    return {
      isError: true,
      message: (res.error ?? 'Error in fetching unique options for column') as string,
      data: null,
      responseStatusCode: res.responseStatusCode,
    };
  }
  return {
    isError: false,
    message: 'Unique options fetched successfully',
    data: res.data[Object.keys(res.data)[0]] as (string | number | null)[],
  };
};
export interface IPayloadForCalculation {
  calculatedFieldName: string;
  flows: IFlows;
  fields: ICalculationFields;
  conditionFilters: IConditionFilters;
}
export const fetchUniqueOptionsForCalculation = async (
  dbConnectionId: string,
  datasetId: string,
  workspaceId: string,
  payload: IPayloadForCalculation[],
) => {
  const res = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: `calculated-field/filter-options?dbconnectionid=${dbConnectionId}&datasetid=${datasetId}&workspaceId=${workspaceId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
    data: payload,
  });
  if (!res.status) {
    Logger('error', 'Error in fetching unique options for calculation', res.data);
    return {
      isError: true,
      message: (res.error ?? 'Error in fetching unique options for calculation') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Unique options fetched successfully',
    data: res.data[Object.keys(res.data)[0]] as (string | number | null)[],
  };
};
interface IRelativeFilterPayload {
  filterTable: {
    tableId: string;
    fieldName: string;
    dataType: string;
    filterOption: string;
    isCalculatedField?: boolean;
    calculatedField?: IPayloadForCalculation[];
  };
  from: (string | number | null)[];
  to: (string | number | null)[];
  anchorDate: string;
}
export const fetchDateRangeFromRelativeRange = async (
  dbConnectionId: string,
  datasetId: string,
  workspaceId: string,
  payload: IRelativeFilterPayload,
) => {
  if (!dbConnectionId && !datasetId) {
    return {
      isError: true,
      message: 'Connection Id or datset Id atleast one of them is required',
      data: null,
    };
  }
  const res = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: `relative-filter?dbconnectionid=${dbConnectionId}&workspaceId=${workspaceId}&datasetid=${datasetId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
    data: payload,
  });
  if (!res.status) {
    Logger('error', 'Error in fetching unique options for calculation', res.data);
    return {
      isError: true,
      message: (res.error ?? 'Error in fetching unique options for calculation') as string,
      data: null,
    };
  }
  const modifiedRes = convertKeysToLowercase(res.data[0]);
  return {
    isError: false,
    message: 'Date range fetched successfully',
    data: { from: modifiedRes['fromdate'], to: modifiedRes['todate'] },
  };
};
export const fetchMinMax = async (
  dbConnectionId: string,
  datasetId: string,
  workspaceId: string,
  payload: IPayloadForColumn,
) => {
  const res = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: `filter-options?dbconnectionid=${dbConnectionId}&datasetid=${datasetId}&workspaceId=${workspaceId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
    data: payload,
  });

  if (!res.status) {
    Logger('error', 'Error in fetching min max for column', res.data);
    return {
      isError: true,
      message: (res.error ?? 'Error in fetching min max for column') as string,
      data: null,
      responseStatusCode: res.responseStatusCode,
    };
  }
  return {
    isError: false,
    message: 'Unique min max fetched successfully',
    data: res.data,
  };
};
